import NotFound from '../views/NotFound';
import Unauthorized from '../views/Unauthorized';
import NotSupportCountry from '../views/NotSupportCountry';

const router = [
  {
    name: 'errors.notFound',
    path: '/404',
    component: NotFound,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'errors.unAuthorized',
    path: '/401',
    component: Unauthorized,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'errors.notSupportCountry',
    path: '/not_support_country',
    component: NotSupportCountry,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '*',
    redirect: '404',
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/errors/router/index.js